import DataTable from "datatables.net-dt"
import "datatables.net-responsive-dt"

export function tables() {
  const items = document.querySelectorAll("table")

  function calculateCells(table) {
    const { rows } = table
    return [rows].reduce(
      (max, row) => (max = Math.max(max, row.cells.length)),
      0,
    )
  }

  items.forEach((item) => {
    if (calculateCells(item) > 2) {
      const initTable = () => {
        const table = new DataTable(item, {
          searching: false,
          ordering: false,
          paging: false,
          responsive: {
            breakpoints: [{ name: "mobile", width: 768 }],
          },
        })

        window.addEventListener("resize", function () {
          table.responsive.recalc()
        })
      }

      initTable()
    }
  })
}
